import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  COMPANY_MODAL_ACTION_TYPE,
  COMPANY_ALL_ACTIONS_TYPE,
  FILTER_ACTION_TYPE,
} from "../../redux/actions-type";
import GlobalHead from "../../globalComponents/GlobalHead/GlobalHead";
import { useLocation } from "react-router-dom";
import { getCompanyPaginationAction } from "../../redux/actions/companiesActions";
import CompanyData from "./components/CompanyData";

const CompanyPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { totalLength, loading, companyData } = useSelector(
    (state) => state.companyPagination,
  );
  const { companySearchValues } = useSelector((state) => state.searchValues);
  const { contractType } = useSelector((state) => state.filter);

  let userData = JSON.parse(localStorage.getItem("userData"));
  userData =
    userData.role !== "super-admin"
      ? userData.profiles
      : JSON.parse(localStorage.getItem("userData"));

  const getNextCompanies = () => {
    if (loading) return;

    dispatch(
      getCompanyPaginationAction(
        companyData?.length || 0,
        companySearchValues || "",
        contractType,
      ),
    );
  };

  const searchData = (e) => {
    e.preventDefault();

    dispatch({
      type: COMPANY_ALL_ACTIONS_TYPE.RESET_COMPANY_PAGINATION,
    });

    dispatch(
      getCompanyPaginationAction(
        0,
        companySearchValues || "",
        contractType || "",
      ),
    );
  };

  const companyFilter = () => {
    dispatch({
      type: COMPANY_ALL_ACTIONS_TYPE.RESET_COMPANY_PAGINATION,
    });

    dispatch(
      getCompanyPaginationAction(
        0,
        companySearchValues || "",
        contractType || "",
      ),
    );
  };

  const openModal = () => {
    dispatch({
      type: COMPANY_MODAL_ACTION_TYPE.GET_COMPANY_MODAL,
      payload: { data: {}, openModal: true },
    });
  };

  useEffect(() => {
    dispatch({
      type: COMPANY_ALL_ACTIONS_TYPE.RESET_COMPANY_PAGINATION,
    });
    dispatch(getCompanyPaginationAction(0, "", ""));

    return () => {
      dispatch({
        type: COMPANY_ALL_ACTIONS_TYPE.RESET_COMPANY_PAGINATION,
      });
      dispatch({
        type: FILTER_ACTION_TYPE.RESET_FILTER_DATA,
      });
    };
  }, [location.pathname]);

  return (
    <div className="details-page consultation ">
      <GlobalHead
        searchData={searchData}
        openModal={openModal}
        DATA_SEARCH_VALUE={"COMPANY_SEARCH_VALUE"}
        dataSearchValues={companySearchValues}
        phoneSearchValues={() => {}}
        PHONE_SEACH_VALUE={""}
        filter={companyFilter}
        statusType="company"
        profile={"company"}
        count={totalLength}
      />

      <CompanyData getNextCompanies={getNextCompanies} userData={userData} />
    </div>
  );
};

export default CompanyPage;
